import { useEffect, useState } from "react";
import "./styles.css";

export default function MobileLayout({
  header,
  footer,
  children,
  className = "",
  frame = true,
  maxWidth = 500,
  fullWidthOnLandscape = true // <- opcional
}) {
  const [isLandscape, setIsLandscape] = useState(false);

  const noFramePaths = [
    "/",
    "/architecture-of-platform",
    "/robustness-of-ryse-methodology",
    "/multi-asset-class-support"
  ];
  const pathname =
    typeof window !== "undefined" ? window.location.pathname : "";
  const skipShellStyle = noFramePaths.includes(pathname);

  useEffect(() => {
    const mm = window.matchMedia("(orientation: landscape)");
    const update = () => setIsLandscape(mm.matches);
    update();
    if (mm.addEventListener) mm.addEventListener("change", update);
    else mm.addListener(update);
    const onResize = () => update();
    window.addEventListener("orientationchange", update);
    window.addEventListener("resize", onResize);
    return () => {
      if (mm.removeEventListener) mm.removeEventListener("change", update);
      else mm.removeListener(update);
      window.removeEventListener("orientationchange", update);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  const computedMaxWidth =
    fullWidthOnLandscape && isLandscape
      ? "none"
      : typeof maxWidth === "number"
      ? `${maxWidth}px`
      : maxWidth;

  return (
    <div className="ml-root">
      <div
        className={["ml-shell", frame ? "ml-shell--framed" : ""].join(" ")}
        style={
          skipShellStyle
            ? undefined
            : { maxWidth: computedMaxWidth, width: "100%" }
        } // <- clave
      >
        {header ? <header className="ml-header">{header}</header> : null}
        <main className={["ml-content", className].join(" ")}>{children}</main>
        {footer ? <footer className="ml-footer">{footer}</footer> : null}
      </div>
    </div>
  );
}
